/**
 * End-of-life date for the old native app version (local time).
 * From this date the update announcement switches to "no longer
 * supported" mode and the app-store redirect screens stop being
 * dismissable.
 */
export const NATIVE_APP_EOL_DATE = new Date(2026, 7, 20);

export const isNativeAppEolReached = (): boolean =>
    Date.now() >= NATIVE_APP_EOL_DATE.getTime();
